export const authKeys = {
  session: () => ["session"] as const,
  user: () => ["user"] as const,
  accounts: () => ["accounts"] as const,
  sessions: () => ["sessions"] as const,
  passkeys: () => ["passkeys"] as const,
};
